import { gold } from "@ant-design/colors"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Modal, Space, Typography } from "antd"

type Props = {
  isOpen: boolean
  onOk: () => void
  onClose: () => void
}

const { Text } = Typography

const RemoveUserModal = ({ isOpen, onOk, onClose }: Props) => {
  return <Modal
    title={<Space><FontAwesomeIcon icon={faInfoCircle} color={gold.primary}/>Remove this User?</Space>}
    okText="Remove"
    cancelText="Cancel"
    open={isOpen}
    onOk={onOk}
    onCancel={onClose}
  >
    <Text>This cannot be undone and will remove all the information regarding this user.</Text>
  </Modal>
}

export default RemoveUserModal